angular.module('jv.Dashboard.Analytics.TimeSeries.Controller', [])
.controller('jv.Dashboard.Analytics.TimeSeries.Controller', ['$scope', 'jvDashboardAjaxService','$timeout', 'jvContextualLoadingService', '$rootScope','jvDashboardFactory', 'jvSearchUrlRedirectService',
    function($scope, jvDashboardAjaxService, $timeout, jvContextualLoadingService, $rootScope,jvDashboardFactory, jvSearchUrlRedirectService) {        
        var postingTypes, subsidiaries, regions, locations, departments, categories, reqTypes, sourceIds, hiringManagerIds;
        $scope.timeseriesValues = [];

        function getAnalyticsTimeSeries() {
            var settingsInfo = $scope.widgetObject.userWidgetSettings.widgetSetting;

            angular.forEach(settingsInfo, function(settingInfo, index){
                var values;
                if (settingInfo.userValues) {
                    values = settingInfo.userValues;
                } else if(settingInfo.settings.defaultValues){
                    values = settingInfo.settings.defaultValues;
                }

                if(values){
                    if(values[0] && angular.isObject(values[0].label) && values[0].EId){
                        values[0].value = angular.copy(values[0].EId);
                        if(values[0].label.name) {
                            values[0].label = angular.copy(values[0].label.name);
                        }
                        /*
                         *  The API for fetching the list of hiring managers has the name returned as fullName.
                         *  We need this for the hiring manager filter in settings
                         */
                        else if(values[0].label.fullName) {
                            values[0].label = angular.copy(values[0].label.fullName);
                        }
                        delete values[0].EId;
                    } else if(values[0].label && values[0].label.name){
                        //filters with label and no EId property Eg: SourceType
                        //posting type has index attribute. Check for undefined as 0 can be a value
                        if( (values[0].label.index != undefined) && (values[0].label.index !== null) ){
                            values[0].index = angular.copy(values[0].label.index);
                        }
                        values[0].value = angular.copy(values[0].label.name);
                        values[0].label = angular.copy(values[0].label.name);
                    }
                    //Making sure UI doesnt make a call with all filter
                    if($.isEmptyObject(values[0].label)){
                        values[0].label = '';
                        values[0].value = null;
                    }
                    switch(settingInfo.settings.name) {
                        case "PostingType":
                            if(values[0]){
                                //check for undefined as 0 can be a value
                                if( (values[0].index != undefined)  && (values[0].index !== null) ){
                                    values[0].value = angular.copy(values[0].index);
                                    delete values[0].index;
                                }
                            }
                            postingTypes = values[0].value;
                            break;
                        case "Company":
                            subsidiaries = values[0].value;
                            break;
                        case "Region":
                            regions = values[0].value;
                            break;
                        case "Location":
                            locations = values[0].value;
                            break;
                        case "Department":
                            departments = values[0].value;
                            break;
                        case "Category":
                            categories = values[0].value;
                            break;
                        case "RequisitionType":
                            reqTypes = values[0].value;
                            break;
                        case "SourceType":
                            sourceIds = values[0].value;
                            $scope.sourceNameFilter = sourceIds;
                            break;
                        case "HiringManager":
                            hiringManagerIds = values[0].value;
                            break;
                        default:
                            break;
                    }
                }

            });
            
            getAnalyticsTimeSeriesSubmittedDate();
        }

        //Get requisition information to show in the widget.
        var getAnalyticsTimeSeriesSubmittedDate = function() {
            
            // prepares the data for rendering in the grid.
            var massageData = function(facetList) {
                angular.forEach(facetList, function(value, key){
                    value.value = moment.utc(value.value).format('DD MMMM');
                });
                $scope.timeseriesValues = facetList;
            };

            var _callback = function(results) {
                if (results && results.facetField && results.facetField.facetValues) {
                    massageData(results.facetField.facetValues);
                    jvContextualLoadingService.hide($scope.widgetObject.widgetId);
                }
            };

            jvContextualLoadingService.show($scope.widgetObject.widgetId);

            var args = {
                fieldId: 'appliedDate',
                subsidiaryId: subsidiaries,
                regionIds: regions,
                locationIds : locations,
                departmentIds : departments,
                categoryIds : categories,
                typeIds : reqTypes,
                postingType:postingTypes,
                sourceIds : sourceIds,
                hiringManagerIds :hiringManagerIds
            };
            /*
            Making sure we send refresh true for new widget creating flow
            Cannot set refresh true in the REFRESH_WIDGET emit callback since the controller gets re-initialized for a newly added widget.
            Hence storing this in the factory 
            */
            if($scope.refresh || jvDashboardFactory.isNewlyAddedWidget($scope.widgetObject) ){
                args.refresh = true;
            }
            jvDashboardAjaxService.getAnalyticsAppTimeSeries(args, _callback);
        };

        $rootScope.$on('REFRESH_WIDGET', function(event,widgetData) {
            if(widgetData && ($scope.widgetObject.widgetId === widgetData.widgetId)){
                 //invalidate cache and fetch data from DB 
                $scope.lastUpdated = '';
                $scope.refresh = true;
                getAnalyticsTimeSeries();
            }
        });

        getAnalyticsTimeSeries();
    }
]);
